import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { TEXT_FIELDS } from '../../customer-service.service';
import { ManageTemplateComponent } from '../../manage-template/manage-template.component';

@Component({
  selector: 'app-business-networks-details',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent],
  templateUrl: './business-networks-details.component.html',
  styleUrls: ['./business-networks-details.component.scss']
})

export class BusinessNetworksDetailsComponent implements OnInit {

  fields : Array<Partial<TEXT_FIELDS>>;
  columns : Array<Partial<TEXT_FIELDS>>;
  businessNetworkDetails !: any;
  userDatas = new BehaviorSubject([]);
  prevSearchAfterKey : any;
  stopScroll : boolean = false;
  placeholderText: string = "Search by business name, business id (or) business email"
  payload = {
    limit: 10,
    searchContent : null,
    type : null,
    statusList : ["ACTIVE", "INACTIVE"],
    searchAfterKey : null,
  }
  businessData: any;
  constructor(private API: ApiService, private _activated_route: ActivatedRoute,
    private util : UtilService
  ) {

    this.fields = [
      {label : "Business Network Name" , key : 'b2bNetworkName' ,
        disabled : false,
        required : true,
        validate : true,
        min : 5,
        max : 30,
        minText : 'Minimum 5 chars is required',
        requiredText : 'Business Network name is required',
        maxText : 'Maximum 30 chars is allowed',
      },
      {label : "Owner" , key : "owner" , disabled : true},
      {label : "Network Type" , key : "typeLabel" , disabled : true},
      {label : "Email" , key : "email" , disabled : true },
      {label : "Role" , key : "role"  , disabled : true},
      {label : "Members" , key : "membersCount" , disabled : true},
     ];

     this.columns = [
      {label : 'GSBID#' , key : 'platformBusinesId', route : true , path : '/user-management/businessContacts/businessConnectEdit'},
      {label : 'Members' , key : 'businessName', route : true , path : '/user-management/businessContacts/businessConnectEdit'},
      {label : 'Owner' , key : 'businessOwner'},
      {label : 'Email' , key : 'businessEmail'},
      {label : 'Title' , key : 'businessOwnerTitle'},
      {label : 'Business Type' , key : 'type'},
     ];

     this.businessNetworkDetails = {
       networkName : "Prasnana",
       owner : "pp@gmail.com",
       members : 10
     }



     this._activated_route.queryParams.subscribe(res => {
      this.businessData = res;
     });


   }

  ngOnInit(): void {
    if (this.businessData.businessNetworkId) {
      this.getBusinessUserNetworkMembers();
    }

  }
  filterData =  [
    {
        label: 'Status',
        payload : 'status',
        options: [
          { value: 'ACTIVE', label: 'Active' },
          { value: 'INACTIVE', label: 'Inactive' },
        ]
      },
    // The Business Type section was removed from this panel (2026-09-24). Every
    // member of a network already shares that network's own type - the Network
    // Type field at the top of this page - so the column only ever holds one
    // value here and filtering on it could not narrow the list.
    // onFilter still forwards `type` when it is set; nothing sets it now.
  ];


  getBusinessUserNetworkMembers() {
    this.util.startLoader();
    this.API.create('business/findB2BNetworkMembers', {
      businessNetworkId: this.businessData.businessNetworkId,
      businessId : this.businessData.id,
      ...this.payload
    }).subscribe(response => {
      this.util.stopLoader();
      if (response.code === AppSettings.SUCESS_CODE) {
        const businessNetworkMembers = response.data.networkMembers;
        const searchKey = response.data.searchAfterKey;

        if (businessNetworkMembers) {
          const current = businessNetworkMembers;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist , ...current]);
        }

        if(businessNetworkMembers != null && (businessNetworkMembers.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))){
          this.stopScroll = true;
        }

        this.prevSearchAfterKey =  searchKey;
        const { userData , ...rest } = response.data.b2bNetwork;
        let data = {
          ...rest,
          // Read-only display of the network type (canonical "Client_Supplier" -> "Client/Supplier").
          typeLabel : this.formatNetworkType(rest.type),
          owner : userData.firstName + " " + userData.lastName,
          email : userData.email,
          role : 'Super Admin'
        }
        this.businessNetworkDetails = data;
      }
    });
  }

  // Display-only mapping for the Business Type field. Backend stores the
  // canonical "Client_Supplier"; the UI must show "Client/Supplier" (matches the
  // networkTypeLabel pipe used on the listing). Never changes the stored value.
  private formatNetworkType(type: string): string {
    if (!type) { return 'N/A'; }
    return type.trim().toLowerCase() === 'client_supplier' ? 'Client/Supplier' : type;
  }

  updateBusinessNetwork(event) {
    this.API.create('business/editB2BNetwork', event).subscribe(res => {
      if (res && res.code === GigsumoConstants.SUCESSCODE) {
        Swal.fire({
          icon : "success",
          title : 'Business Network Updated!',
          text : 'Business network updated successfully',
          showConfirmButton: false,
          allowOutsideClick : false,
          timer: 1000,
        });
        this.businessNetworkDetails = event;
      }
      this.util.stopLoader();
    });
  }


  updateBusinessNetworkMembers(members: any) {
    const userData = members.value;
    let data = {
      businessNetworkId: this.businessData.businessNetworkId,
      businessId : userData.businessId,
      status: userData.connectionStatus
    }

    if(members.checked){
       this.updateMembersbulk(data);
    }
    else{
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        allowOutsideClick : false,
        cancelButtonText: 'No',
        title : "Inactive Business " + userData.businessName,
        text : `Are you sure you want to move ${userData.businessName} to inactive state?`
      }).then(res=>{

        this.util.startLoader();
        const  updatedData =  JSON.parse(JSON.stringify(this.userDatas.getValue()));

        if(res.isConfirmed){
          this.updateMembersbulk(data);
          this.util.stopLoader();
        }
        else{
          updatedData.forEach(res=>{
            if(res.b2bNetworkId === userData.b2bNetworkId){
              res.connectionStatus = "ACTIVE";
            }
          });
          this.userDatas.next(updatedData);
          this.util.stopLoader();
        }



      });


    }

  }


  updateMembersbulk(data){
    this.util.startLoader();
    this.API.create('business/updateB2BNetworkMember', data).subscribe(res => {
      if(res) {
        this.util.stopLoader();
      }
      if (res && res.code === '00000') {
        Swal.fire({
          icon : "success",
          title : 'Users Updated!',
          text : 'User updated successfully',
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.userDatas.next([]);
          this.getBusinessUserNetworkMembers();
        }, 1000);
      }
    });
  }


  onSearch(value , obj : BusinessNetworksDetailsComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onFilter(data , obj : BusinessNetworksDetailsComponent){
    console.log("FILTERED DATA" , data);
    obj.payload = {
      ...obj.payload,
      statusList : data.status != null ? [data.status] : ["ACTIVE", "INACTIVE"],
      type : data.type,
      searchAfterKey : null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onScroll(obj : BusinessNetworksDetailsComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getBusinessUserNetworkMembers();
    }
  }



}
